import { Link } from "../../link";
import { forwardRef } from "react";
import { cssModule, mergeProps } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { useTile } from "./useTile";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "a";
export function InnerTileLink({
  active,
  as = DefaultElement,
  children,
  disabled,
  focus,
  forwardedRef,
  hover,
  orientation = "vertical",
  ...rest
}) {
  const orientationValue = useResponsiveValue(orientation);
  const {
    markup,
    tileProps
  } = useTile({
    active,
    children,
    focus,
    hover,
    orientation: orientationValue,
    variant: "link"
  });
  return /*#__PURE__*/_jsx(Link, { ...mergeProps(rest, {
      active,
      as,
      className: cssModule("o-ui-tile-link", disabled && "disabled"),
      disabled,
      focus,
      hover,
      ref: forwardedRef
    }, tileProps),
    children: markup
  });
}
InnerTileLink.defaultElement = DefaultElement;
export const TileLink = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerTileLink, { ...props,
  forwardedRef: ref
}));